import React, { useEffect } from 'react';
import "../register.css";
import { AuthContext } from "../../AuthContext";
import * as FaIcons from 'react-icons/fa';
import { useViewPort } from '../Hooks/useViewPort';
import { AddressRow } from './AddressRow';
import { EditingAddressRow } from './EditingAddressRow';
import { NewAddressRow } from './NewAddressRow';

const TableAddress = (props) => {
    const authContext = React.useContext(AuthContext);
    const params = props.params;
    const [initialAddress] = React.useState({ idServiceType: 1, addressValue: params.email, addressOption: "html", checkcode: null, checkvalidate: false, checkdate: null, addressesrequiretest: false });
    const [addresses, setAddresses] = React.useState(params.addresses.length > 0 ? params?.addresses.map((a, i) => ({ ...a, id: i })) ?? [] : props.params.idUser === 0 ? [initialAddress].map((a, i) => ({ ...a, id: i })): []);
    const [editingAddressId, setEditingAddressId] = React.useState();
    const [isAdding, setIsAdding] = React.useState(false);
    const [isModified, setIsModified] = React.useState(false);
    const [responseMessage, setResponseMessage] = React.useState("");
    const { width } = useViewPort();
    const breakpoint = 520;

    React.useEffect(() => {
        props.isButtonDisabled(isModified);
    }, []);

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    const handleChangeIsModified = (isModified) => {
        setIsModified(isModified);
    }

    const handleChangeMessage = (responseMessage) => {
        setResponseMessage(responseMessage);
    }

    const handleDeleteAddress = (addressId) => {
        setAddresses(aa => aa.filter(a => a.id !== addressId));
    }

    const handleEditAddress = (addressId) => {
        setEditingAddressId(addressId);
    }

    const handleDismissEdit = () => {
        setEditingAddressId(undefined);
        handleChangeButton(false);
        setResponseMessage(null);
    }

    const handleCancelRow = () => {
        setIsAdding(false);
        handleChangeButton(false);
        setResponseMessage(null);
    }

    const handleSaveAddress = (address) => {
        if (isModified === true) {
            const err = checkAddress(address);
            if (err === "") {
                setAddresses(aa => {
                    let newAddresses = [...aa];
                    const addressIndex = newAddresses.findIndex(a => a.id === address.id);
                    if (addressIndex === -1) {
                        var id = Math.max.apply(Math, newAddresses.map(a => a.id));
                        newAddresses.push({ ...address, id: isFinite(id) ? id + 1 : 0 });
                    }
                    else
                        newAddresses[addressIndex] = address;

                    return newAddresses
                });
                setEditingAddressId(undefined);
                handleChangeButton(false);
                setIsAdding(false);
                setResponseMessage(err);
                setIsModified(false);
            }
            else {

                setResponseMessage(err);
            }
        }
        else {
            setEditingAddressId(undefined);
            handleChangeButton(false);
            setIsAdding(false);
        }
    }

    const checkAddress = (address) => {
        let array = [...addresses];
        let message = "";

        const addressIndex = array.findIndex(a => a.addressValue === address.addressValue);

        if (addressIndex > -1) {
            message = "Address Value already exist,please check.";
        }

        if (address.idServiceType === 3) {
            let c = addresses.filter(x => x.idServiceType === 3).length;
            if (c > 4)
                message = "For SMS please specify max 5 numbers";
        }

        if (address.idServiceType === 10) {
            let c = addresses.filter(x => x.idServiceType === 3).length;
            if (c > 1)
                message = "";
        }

        if (address.idServiceType === 1 && address.addressValue !== "undefined") {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(address.addressValue)) {
                /*            isValid = false;*/
                message = "Please enter valid email address.";
            }
        }

        if (address.idServiceType === 3 && address.addressValue !== "undefined") {
            var pattern = new RegExp(/^[+]?\d+$/);
            var codeCountry = new RegExp(/^[+]/);
            if (!pattern.test(address.addressValue)) {
                /*                isValid = false;*/
                /*                errors["phone"] = "Please enter only number.";*/
                message = "Please enter only number.";
            } else if (address.addressValue.length < 8) {
                /*                isValid = false;*/
                message = "The number inserted contains numbers not enough long to be validated. Please enter valid phone number.";
            }
            if (!codeCountry.test(address.addressValue)) {
                message = "The number has to start with symbol plus (+), followed by code country.";
            }
        }

        if (address.idServiceType === 10 && address.addressValue === "undefined") {
            {
                /*            isValid = false;*/
                message = "For APP service click only the button Add";
            }
        }

        return message;
    }


    React.useEffect(() => {
        props.onChange(addresses);
        props.isButtonDisabled(isModified);
    }, [addresses, isModified]);

    return (
        <div>
            <table className={width < breakpoint ? "table generic_detail_mobile" : "table generic_detail"} id="address">
                <thead style={{ backgroundColor: "#0099CC", color: "white" }}>
                    <tr>
                        <th className="cell_hidden">Id</th>
                        <th className="cell_hidden">IdUserAddress</th>
                        <th>Channel</th>
                        <th>Address</th>
                        <th>Option</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        addresses.sort((a, b) => a.idServiceType > b.idServiceType ? 1 : -1).map((address) => {
                            if (address.id === editingAddressId)
                                return <EditingAddressRow address={address} onRequestSaveAddress={handleSaveAddress} onRequestDismissEdit={handleDismissEdit} isButtonDisabled={handleChangeButton} responseMessage={handleChangeMessage} isModified={handleChangeIsModified} />
                            return <AddressRow address={address} onRequestDeleteAddress={handleDeleteAddress} onRequestEditAddress={handleEditAddress} />
                        })
                    }
                    {
                        addresses.length === 0 &&
                        <tr>
                            <td style={{ textAlign: "center" }}>No Channel found.</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    }
                    {
                    isAdding &&
                    < NewAddressRow address={addresses} onRequestSaveAddress={handleSaveAddress} onRequestCancelRow={handleCancelRow} isButtonDisabled={handleChangeButton} responseMessage={handleChangeMessage} isModified={handleChangeIsModified} />
                }
                {
                    !isAdding &&
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <button className="btn btn-primary btn_table" style={{ backgroundColor: "#0099CC" }} onClick={() => setIsAdding(true)} type='button'><FaIcons.FaPlus style={{ height: '20px' }} /></button>
                        </td>
                    </tr>
                }
                </tbody>
            </table>
            {
        responseMessage &&
        <div className="input-feedback col-12">{responseMessage}</div>
    }
        </div >
    )
}

export { TableAddress };